import { render, staticRenderFns } from "./development-person.vue?vue&type=template&id=095258fb&scoped=true&"
import script from "./development-person.vue?vue&type=script&lang=js&"
export * from "./development-person.vue?vue&type=script&lang=js&"
import style0 from "./development-person.vue?vue&type=style&index=0&id=095258fb&scoped=true&lang=css&"
import style1 from "./development-person.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095258fb",
  null
  
)

export default component.exports